var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfilePicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 291,
    height: 291,
    viewBox: "0 0 291 291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_848",
    "data-name": "Grupo 848",
    transform: "translate(3368 11050)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_218",
    "data-name": "Caminho 218",
    d: "M145.5,0A145.5,145.5,0,1,1,0,145.5,145.5,145.5,0,0,1,145.5,0Z",
    transform: "translate(-3368 -11050)",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_215",
    "data-name": "Caminho 215",
    d: "M283.178,40H228.012v91.943H241.8V95.166h41.374a27.583,27.583,0,0,0,0-55.166m0,41.374H241.8V53.791h41.374a13.791,13.791,0,0,1,0,27.583",
    transform: "translate(-3448.67 -10972.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_216",
    "data-name": "Caminho 216",
    d: "M159.986,0H45.971a45.972,45.972,0,0,0,0,91.943h54.252V78.152H45.971a32.18,32.18,0,0,1,0-64.36H159.986a32.18,32.18,0,0,1,0,64.36H123.209V91.943h36.777a45.972,45.972,0,0,0,0-91.943",
    transform: "translate(-3325.479 -10950.666)",
    fill: "#55f5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_217",
    "data-name": "Caminho 217",
    d: "M95.166,53.791a13.792,13.792,0,0,1,0,27.583H67.583a13.792,13.792,0,0,1,0-27.583Zm0-13.791H67.583a27.583,27.583,0,0,0,0,55.166H95.166a27.583,27.583,0,0,0,0-55.166",
    transform: "translate(-3347.09 -10972.277)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicture);
export default __webpack_public_path__ + "static/media/profilePicture.d2c33f3e80fcd45e5fc684e8de46e6a6.svg";
export { ForwardRef as ReactComponent };